// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ScheduledJobs_HistoryResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ScheduledJobs_HistoryResponse — GET /scheduled-jobs/{id}/history.
 *
 * Also reused, with a single-element `rows`, as the response of
 * POST /scheduled-jobs/run-now — see ScheduledJobs_RunRow docblock for why
 * that endpoint's real answer is inside the row, not the envelope.
 */
import type { ScheduledJobs_RunRow } from './ScheduledJobs_RunRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ScheduledJobs_HistoryResponseDados {
rows: ScheduledJobs_RunRow[]
}

export type ScheduledJobs_HistoryResponse = ApiResponse<ScheduledJobs_HistoryResponseDados>;

registerResponseContract('ScheduledJobs_HistoryResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      id:             { type: 'number',  required: true },
      job_id:         { type: 'number',  required: true },
      scheduled_for:  { type: 'string',  required: false },
      status:         { type: 'string',  required: false },
      attempts:       { type: 'number',  required: false },
      started_at:     { type: 'string',  required: false },
      finished_at:    { type: 'string',  required: false },
      error_message:  { type: 'string',  required: false },
      result_summary: { type: 'string',  required: false },
      created_at:     { type: 'string',  required: false },
    },
  },
})
